'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _envs = require('../configs/envs');

var environmentConstant = _interopRequireWildcard(_envs);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = process.env.NODE_ENV || environmentConstant.PRODUCTION; /**
                                                                           * @since 2016-06-11 15:43
                                                                           * @author vivaxy
                                                                           */


//////////////////
// WEBPACK FOOTER
// ./~/@dp/cmp-prototype-lib/lib/environment.js
// module id = 98
// module chunks = 0